import React from "react";
import { Field } from "redux-form";
import {
  // DatePicker,
  SelectField,
  TextField
} from "redux-form-material-ui";
import MenuItem from "material-ui/MenuItem";
import "./styles.css";

let muiStyles = {
  inputStyle: {
    fontWeight: "400",
    fontFamily: '"Montserrat", sans-serif'
  }
};

const backspaceOrDeletePressed = event =>
  event.keyCode === 8 || event.keyCode === 46;
const limitEntryToTen = event => {
  // If input size is 10,
  if (event.target.value.length === 10) {
    event.preventDefault(); // stop further chars from entering input
  }
};
const preventNonDigitEntry = event => {
  var isSpaceKeyPressed = event.which === 32;
  // Prevent non-digits from being entered -- space key escapes first logic block, so it is captured separately
  if (
    (!backspaceOrDeletePressed(event) &&
      isNaN(String.fromCharCode(event.which))) ||
    isSpaceKeyPressed
  ) {
    event.preventDefault(); //stop character from entering input
  }
};
const isLastCharMinus = val => {
  const lastChar = val.slice(val.length - 1, val.length);
  return lastChar === "-";
};

let TravellerForm = ({ formInfo, handleDateOfBirthChange, showHeader }) => (
  <div>
    {showHeader && <div class="traveller-form__header"> {formInfo.id} </div>}
    <div class="traveller-form">
      {/* Note: formInfo.id is "Adult 1", "Adult 2" etc. */}
      <Field
        class="traveller-form__item--small"
        component={SelectField}
        name={formInfo.gender}
        floatingLabelText="Gender"
        hintStyle={muiStyles.inputStyle}
        inputStyle={muiStyles.inputStyle}
        floatingLabelStyle={muiStyles.inputStyle}
        fullWidth
      >
        {[
          <MenuItem key="M" value={"M"} primaryText="M" />,
          <MenuItem key="F" value={"F"} primaryText="F" />
        ]}
      </Field>
      <Field
        class="traveller-form__item"
        name={formInfo.firstName}
        component={TextField}
        floatingLabelText="First Name"
        hintStyle={muiStyles.inputStyle}
        inputStyle={muiStyles.inputStyle}
        floatingLabelStyle={muiStyles.inputStyle}
        fullWidth
      />
      <Field
        class="traveller-form__item"
        name={formInfo.lastName}
        component={TextField}
        floatingLabelText="Last Name"
        hintStyle={muiStyles.inputStyle}
        inputStyle={muiStyles.inputStyle}
        floatingLabelStyle={muiStyles.inputStyle}
        fullWidth
      />
      <Field
        class="traveller-form__item"
        name={formInfo.dob}
        component={TextField}
        floatingLabelText="Birthday (YYYY-MM-DD)"
        onKeyPress={event => {
          preventNonDigitEntry(event);
          limitEntryToTen(event);
        }}
        onKeyUp={event => {
          // event.preventDefault() // prevents Redux-form from auto updating field, as a Redux-form update of
          // the field would override our custom field update happening below
          preventNonDigitEntry(event);
          limitEntryToTen(event);

          // const key = event.keyCode
          const input = event.target.value;
          const inputLength = input.length;
          const isBackspaceOrDeletePressed = backspaceOrDeletePressed(event);
          var formattedInput;

          // console.log('DEBUG input', input)
          // console.log('DEBUG key', key)
          // console.log('DEBUG isBackspaceOrDeletePressed', isBackspaceOrDeletePressed)

          if (inputLength === 5 && !isLastCharMinus(input)) {
            // Prevent rapid entry of fifth char. If input is 199, and you enter 19 rapidly, you'll get 19919
            // instead of intended 1991-9
            formattedInput = `${input.slice(0, 4)}-`;
          } else if (inputLength === 8 && !isLastCharMinus(input)) {
            // Prevent rapid entry of 8th char. If input is 1991-1, and you enter 19 rapidly, you'll get 1991-119
            // instead of intended 1991-11-9
            formattedInput = `${input.slice(0, 7)}-`;
          } else if (isBackspaceOrDeletePressed) {
            if (inputLength === 4) {
              // Ensure backspace/del of "1986-" will be "198" => THIS DOES NOT PREVENT BUTTON HOLD DOWN
              formattedInput = input.slice(0, 3);
            }
            if (inputLength === 7) {
              // Ensure backspace/del of "1986-06" will be "1986-0" => THIS DOES NOT PREVENT BUTTON HOLD DOWN
              formattedInput = input.slice(0, 6);
            }
          } else if (!isBackspaceOrDeletePressed) {
            // Ensure typing of "198" will be "1986-" or "1986-06" will be "1986-06-"
            if (inputLength === 4 || inputLength === 7) {
              formattedInput = `${input}-`;
            }
          } else {
            formattedInput = input;
          }

          // Modify the Redux-Form value of DOB
          handleDateOfBirthChange(formInfo.dob, formattedInput);
        }}
        inputStyle={muiStyles.inputStyle}
        floatingLabelStyle={muiStyles.inputStyle}
        fullWidth
      />
    </div>
  </div>
);

export default TravellerForm;

//     <Field
//       class='traveller-form__item'
//       name={formInfo.dob}
//       component={DatePicker}
//       floatingLabelText='Date of Birth'
//       format={null}
//       onChange={(value) => {
// // console.log('date changed ', value) // eslint-disable-line no-console
//       }}
//       inputStyle={muiStyles.inputStyle}
//       floatingLabelStyle={muiStyles.inputStyle}
//       fullWidth
//     />



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/components/TravellerForm/index.js